import React, { forwardRef } from "react";
import { injectIntl } from "react-intl";
import { intlShape } from "../shapes";

type WithIntlProps = {
  intl: intlShape;
  innerRef?: React.Ref<$TSFixMe>;
};

function withIntl<T extends WithIntlProps = WithIntlProps>(
  WrappedComponent: React.ComponentType<T>,
) {
  function Wrapper(props: Readonly<T>) {
    const { innerRef, ...restProps } = props;
    const t = (id: string, ...args: $TSFixMe[]) =>
      restProps.intl.formatMessage({ id }, ...args);
    const newProps = { ...restProps, intl: { ...restProps.intl, t } };
    return <WrappedComponent {...(newProps as T)} ref={innerRef} />;
  }

  const ComponentWithIntl = injectIntl(Wrapper);

  const ComponentWithRef = forwardRef<$TSFixMe, Omit<T, keyof WithIntlProps>>(
    (props, ref) => <ComponentWithIntl {...(props as T)} innerRef={ref} />,
  );

  ComponentWithRef.displayName =
    WrappedComponent.displayName ?? WrappedComponent.name;

  return ComponentWithRef;
}

export default withIntl;
